import { render, staticRenderFns } from "./VmsSetupChecklist.vue?vue&type=template&id=06204ab0"
import script from "./VmsSetupChecklist.vue?vue&type=script&lang=js"
export * from "./VmsSetupChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports